// import {SpanIcon} from '@mazraeapp/react_icon_kit';

import classNames from 'classnames';

interface IStepsArray {
  label: string;
  id: number;
  isActive?: boolean;
}
interface StepperProps {
  currentStep: number;
  steps: Array<IStepsArray>;
}


const Stepper = ({steps, currentStep}: StepperProps) => {
  return (
    <div className="flex w-full ">
      {steps.map((item, index) => {
        return (
          <div
            key={item.id}
            className={classNames('flex w-full items-center', {
              'justify-end !w-fit': index + 1 === steps.length,
            })}
          >
            <div className="flex flex-col relative">
              <i
                className={classNames('text-xxl ', {
                  'text-farm-shop-500 icon-nameCheck-circle':
                    currentStep > index + 1,
                  'text-farm-shop-500 icon-namecurrent-circle':
                    currentStep === index + 1,
                  'text-gray-500 icon-namecurrent-circle':
                    currentStep < index + 1,
                })}
              />
              <span
                className={classNames('absolute text-xs top-7 !min-w-max', {
                  'right-0': index === 0,
                  'left-0': index === steps.length - 1,
                  '-translate-x-1/2 left-1/2':
                    index !== 0 && index !== steps.length - 1,
                })}
              >
                {item.label}
              </span>
            </div>
            {steps.length !== index + 1 && (
              <div
                className={classNames(`flex w-full h-[1px] min-w-10`, {
                  'bg-farm-shop-500': currentStep >= index + 1,
                  'bg-gray-500': currentStep <= index + 1,
                })}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
